import idLocale from 'element-ui/lib/locale/lang/id'
import home from './id/home'

const id = {
    language: 'Bahasa Indonesia',
    message: {
        'home': home,
    },
    '手机号码最小长度为8位': 'Panjang nomor ponsel minimal 8 digit',
    '邮箱账号名称最小长度为6位': 'Panjang minimal nama akun email adalah 6 karakter',
    '邮箱只能包含英文，数字等字符': 'Kotak surat hanya boleh berisi bahasa Inggris, angka, dan karakter lainnya',
    '请选择正确的收货地址': 'Silakan pilih alamat pengiriman yang benar',
    ...idLocale
}
export default id